// src/lib/withRouter.js
import React from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";

/**
 * Higher Order Component to provide React Router v6 hooks to class components
 * Provides navigate and location props to wrapped component
 */
export function withRouter(Component) {
  return function ComponentWithRouterProp(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    return (
      <Component
        {...props}
        navigate={navigate}
        location={location}
        params={params}
        // Create history-like object for backward compatibility
        history={{
          push: (path) => navigate(path),
          replace: (path) => navigate(path, { replace: true }),
          location: location,
        }}
      />
    );
  };
}

export default withRouter;
